import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useQueryString from "utils/hooks/useQueryString";

export const HeaderSearch = ()=>{
    const navigate = useNavigate();
    const { school } = useParams();
    const [keyword, setKeyword] = useState("");
    const {search_keyword} = useQueryString();
    useEffect(() => {
      setKeyword((search_keyword===undefined)?'':search_keyword);
    }, [search_keyword]);

    function submitHandler(event){
        navigate({pathname:`/${school}/book`, search:`search_keyword=${ encodeURIComponent(keyword)}` });
        event.preventDefault();
    }
    return (
        <div className="search_area">
            <form onSubmit={submitHandler}>
                <input type="text" className="search_input" placeholder="도서검색"
                    name="keyword" value={keyword} onChange={(e)=>setKeyword(e.target.value)} />
                <button type="submit" className="search_btn"></button>
            </form>
        </div>
    );
    
}